// extracted by mini-css-extract-plugin
export default {"stat-card":"BiddersEligibleForRefund_stat-card__62Yrk","stats-container":"BiddersEligibleForRefund_stats-container__e89VS"};